module.exports = __webpack_public_path__ + "img/list_bulleted.3638edd9.svg";